import { render, staticRenderFns } from "./createBenefitType.vue?vue&type=template&id=9a0a0f3a&"
import script from "./createBenefitType.vue?vue&type=script&lang=js&"
export * from "./createBenefitType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports